export default "__VITE_ASSET__676b63f6__"